import dayjs from 'dayjs'
export function dateformat (value) {
  return dayjs(value).format('YYYY-MM-DD')
}



//////////////////
// WEBPACK FOOTER
// ./src/filters/index.js
// module id = null
// module chunks = 